import { getContainer } from './inversify.config';

/* === Entry Point for Jetfabric client SDK UMD module ===
 * Exports:
 *   V1ClientSDK class
 *   v1 (V1ClientSDK class instance)
 */

import { DI_TYPES } from './di-types';
import { V2ClientSDK } from './v2/v2clientsdk';

const v2 = getContainer().get<V2ClientSDK>(DI_TYPES.V2ClientSDK);

// This is for tracing / debugging purposes only
if (window.sessionStorage) {
  const debugFnSrc = window.sessionStorage.getItem('jfClientSDKDebugFn');
  if (debugFnSrc) {
    (eval(debugFnSrc) as (v2: V2ClientSDK) => any)(v2);
  }
}

export { getContainer, v2 };
